import axios from "lib/api";
import { mapSuppliersToUi, mapTrucksToUi } from "./mapOptionsT0Ui";

export const getAllTruckTypes = async () => {
    try {
        const response = await axios.get("/truck-types/filters", {
            params: {
                key: "classes",
            },
        });
        return response.data.attributes.classes;
    } catch (error) {
        return error;
    }
};

export const getAllBoxTypes = async (truckClass) => {
    try {
        const response = await axios.get(`/truck-types?filter[truckClass]=${truckClass}`);
        return mapTrucksToUi(response.entities.truckTypes);
    } catch (error) {
        return error;
    }
};

export const getAllSuppliers = async (filter) => {
    const response = await axios.get("/suppliers", {
        params: {
            ...(filter && { "filter[name]": filter }),
        },
    });
    return mapSuppliersToUi(response.entities.suppliers);
};

export const getAllYears = async () => {
    const response = await axios.get("/trucks/filters", {
        params: {
            key: "years",
        },
    });
    return response.data.attributes.years
}
